import React from "react";
import Bio from "../components/Bio";
import { Link } from "react-router-dom";

const About = () => {
    return (
        <div className="container">
            <div className="nav-left">
                <div className="nav-left-item">
                    <Link to="/" className="nav-left-link">
                        HOME
                    </Link>
                </div>
                <div className="nav-line"></div>
                <div className="nav-left-item nav-copyright">
                    <div class="copyright">©/2022</div>
                </div>
            </div>

            <Bio />
        </div>
    );
};

export default About;
